var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.content),function(item,i){return _c('plan-result-item',_vm._g({key:i,attrs:{"data":item,"tab-data":_vm.tabData,"route":_vm.route}},_vm.$listeners))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }